import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "mag-glass-64", viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { stroke: "currentColor", strokeWidth: 3, fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M28 46.5c10.217 0 18.5-8.283 18.5-18.5S38.217 9.5 28 9.5 9.5 17.783 9.5 28 17.783 46.5 28 46.5z" }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M42 42l13.5 13.5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
